import { enrollmentApiRequest } from "./client";
import { useMutation } from "react-query";
import { ENROLLMENT_SESSION_TOKEN } from "../config/app-config";
var SessionFinalizationReason = /* @__PURE__ */ ((SessionFinalizationReason2) => {
  SessionFinalizationReason2["LogOut"] = "LogOut";
  SessionFinalizationReason2["Replaced"] = "Replaced";
  SessionFinalizationReason2["Completed"] = "Completed";
  SessionFinalizationReason2["ParentPubliclyRefreshed"] = "ParentPubliclyRefreshed";
  SessionFinalizationReason2["ParentFinalized"] = "ParentFinalized";
  SessionFinalizationReason2["Exited"] = "Exited";
  SessionFinalizationReason2["Paused"] = "Paused";
  SessionFinalizationReason2["Expired"] = "Expired";
  SessionFinalizationReason2["ForceClose"] = "ForceClose";
  return SessionFinalizationReason2;
})(SessionFinalizationReason || {});
function finalizeEnrollmentSession(finalizeSessionRequest) {
  return enrollmentApiRequest({
    url: `/enrollment/sessions/enrollment-session/finalize`,
    method: "POST",
    data: finalizeSessionRequest
  }).catch((error) => {
    if ((error == null ? void 0 : error.status) == 404) {
      console.warn("Session already expired.", error == null ? void 0 : error.message);
      return;
    }
    throw error;
  });
}
function useFinalizeEnrollmentSessionMutation() {
  return useMutation(
    (finalizeSessionRequest) => finalizeEnrollmentSession(finalizeSessionRequest),
    {
      useErrorBoundary: true
    }
  );
}
function keepEnrollmentSessionAlive(req) {
  return enrollmentApiRequest({
    url: "/enrollment/sessions/enrollment-session/keep-alive",
    method: "POST",
    data: req,
    timeout: 5 * 60 * 1e3
  });
}
function keepEnrollmentAttemptSessionAlive(req) {
  return enrollmentApiRequest({
    url: req.isReviewMode ? "/enrollment/sessions/attempt-review-session/keep-alive" : "/enrollment/sessions/attempt-take-session/keep-alive",
    method: "POST",
    data: req,
    timeout: 5 * 60 * 1e3
  });
}
function useEnrollmentSessionKeepAliveMutation() {
  return useMutation(keepEnrollmentSessionAlive);
}
function useEnrollmentAttemptSessionKeepAliveMutation() {
  return useMutation(keepEnrollmentAttemptSessionAlive);
}
function buildFinalizeSessionRequest(reason) {
  const sessionToken = sessionStorage.getItem(ENROLLMENT_SESSION_TOKEN);
  const finalizeSessionRequest = {
    sessionToken,
    finalizationReason: reason
  };
  return finalizeSessionRequest;
}
export {
  SessionFinalizationReason,
  buildFinalizeSessionRequest,
  useEnrollmentAttemptSessionKeepAliveMutation,
  useEnrollmentSessionKeepAliveMutation,
  useFinalizeEnrollmentSessionMutation
};
